import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardDTO } from "../../models/atgard-models";

import { AtgardBaseCommand } from "./AtgardBaseCommand";
export class UpdateAtgardCommand extends AtgardBaseCommand {
    readonly atgard: VKAtgardDTO;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAtgardCommand";

    constructor(atgard: VKAtgardDTO, kontraktGuid: string) {
        super(UpdateAtgardCommand.$type, CommandType.Replace);
        this.atgard = atgard;
        this.kontraktGuid = kontraktGuid;
        this.atgardGuid = atgard.guid;
    }
}
